import { createClient } from '@supabase/supabase-js';

// IMPORTANT: Replace with your Supabase project's URL and Anon Key
const supabaseUrl = 'https://dgnhapsqrmhmpenlapvc.supabase.co'; 
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRnbmhhcHNxcm1obXBlbmxhcHZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0OTc1OTIsImV4cCI6MjA3NTA3MzU5Mn0.mNTHfCGXo7xvoKXHk4C7aM9xnBSeODkWmlV5sAnrQaM';

// In a real production app, you would use environment variables:
// const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
// const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;


if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL and Anon Key are required.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
